// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__0vc+0","rotating":"Spinner_rotating__1jptH"};